import script from "./ExportRecordDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./ExportRecordDrawer.vue?vue&type=script&setup=true&lang=js"

import "./ExportRecordDrawer.vue?vue&type=style&index=0&id=2a2f3bd7&lang=css"

const __exports__ = script;

export default __exports__